import Vue from 'vue'
import App from './App.vue'
// import router from './routerManuaConfig'
import store from './store'
import router from './router/index'
import '../util/global' //全局
import './promissionRouter' //这里进行路由后台获取的模拟
import i18n from './lang' // Internationalization

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI, {
    size: 'small', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
});

import 'font-awesome/css/font-awesome.min.css'

import GL_Component from "util/globalComponents";
Vue.use(GL_Component);

Vue.config.productionTip = false
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')